export const testIds = {
  test: 'test',
  filterGroup: 'FilterGroup',
  closeButton: 'CloseButton',
  radioOptionButton: 'RadioOptionButton',
  searchOptionButton: 'SearchOptionButton',
  breadcrumbLink: 'BreadcrumbLink',
  dropdownSection: 'DropdownSection',
  keyFacts: 'KeyFacts',
  tabLink: 'TabLink',
  label: 'Label',
  description: 'Description',

  // Mobile app search elements
  advancedSearchMobile: 'advancedSearchMobile',
  mobileSearchField: 'mobileSearchField',
  mobileSearchButton: 'mobileSearchButton',
  // Area page pagination
  pageNavigation: 'pageNavigation',
  pageNavigationForwardArrow: 'ChevronRightIcon',
  pageNavigationBackArrow: 'ChevronLeftIcon',
  // Notification banner
  notificationBannerClose: 'notificationBannerClose',
  notificationBannerComponent: 'notificationBannerComponent',
  notificationBannerLabel: 'notificationBannerLabel',
  notificationBannerLink: 'notificationBannerLink',
  // Open house
  openhousesTitle: 'openhousesTitle',
  // Sitemap
  sitemapCity: 'SitemapCity',
  sitemapProvince: 'SitemapProvince',
  // Internal links
  internalLink: 'internalLink',
  internalLinkContent: 'internalLinkContent',
  internalLinksContainer: 'internalLinksContainer',
  // Warning popup
  warningPopupContainer: 'warningPopupContainer',
  warningPopupCloseIcon: 'warningPopupCloseIcon',

  // Empty state
  emptyState: 'empty-state',

  chartGradient: 'chartGradient',
  ctaCard: 'ctaCard',
  ctaButton: 'ctaButton',
  homeCTALink: 'homeCTALink',
  imageDescription: 'imageDescription',

  loadingSkeleton: 'loadingSkeleton',
  carouselNext: 'carouselNext',
  carouselPrev: 'carouselPrev',
  modalInner: 'modalInner',
  listingGridBreadcrumbs: 'listingGridBreadcrumbs',
  defaultBreadcrumbs: 'defaultBreadcrumbs',
  emberNext: 'emberNext',
  formWarning: 'formWarning',
  expandIcon: 'expandIcon',
  schoolPin: 'schoolPin',
  userIcon: 'userIcon',
  mobileuser: 'mobileuser',
  loadingSpinner: 'loadingSpinner',
  reviewsSellPage: 'reviewsSellPage',
  suggestedLocationsDropdown: 'suggestedLocationsDropdown',
  mortgageCalculatorHeading: 'mortgageCalculatorHeading',
  mortgageCalculatorDescription: 'mortgageCalculatorDescription',
  calculateMonthlyPaymentHeader: 'calculateMonthlyPaymentHeader',
  connectWithAgentModal: 'connectWithAgent',
  connectWithAgentSubmit: 'connectWithAgentSubmit',
  leadFormSubmit: 'leadFormSubmit',
  leadFormSuccessMessage: 'leadFormSuccessMessage',
  leadFormDisclaimerError: 'leadFormDisclaimerError',
  speakWithExpertButton: 'speakWithExpertButton',
  listingGrid: 'listingGrid',
  itsoVowAgreementModal: 'itsoVowAgreementModal',
  itsoVowAgreementAcceptButton: 'itsoVowAgreementAcceptButton',
  homeWorthButton: 'homeWorthButton',
  appBannerNotNow: 'appBannerNotNow',
  areaGuides: 'areaGuides',
  marketInsights: 'marketInsights',
  cityGuide: 'cityGuide',
  infraGuide: 'infraGuide',
  taxGuide: 'taxGuide',
  testField: 'testField',
  toggle: 'toggle',
  emailAlertRadioButton: 'emailAlertRadioButton',
  buyingGuide: 'buyingGuide',
  menuButton: 'menuButton',
  menuDropdownOption: 'MenuDropdownOption',
  addMoreCard: 'AddMoreCard',
  formMessageError: 'formError',
} as const;

export const dynamicTestIds = {
  activeRadioButton: 'activeRadioButton',
  inactiveRadioButton: 'inactiveRadioButton',
  favourite: 'favourite',
  notFavourite: 'notFavourite',
  fullScreenListings: 'fullScreenListings',
  sidebarListings: 'sidebarListings',
} as const;

export const homepageIds = {
  homepageSearchHeader: 'homepageSearchHeader',
  homepageSearchbar: 'homepageSearchbar',
  homepageSearchField: 'homepageSearchField',
  homepageSearchButton: 'homepageSearchButton',
  homePageBrushStroke1: 'homePageBrushStroke1',
  homePageBrushStroke2: 'homePageBrushStroke2',
  homePageBrushStroke3: 'homePageBrushStroke3',
  homesForSaleWidget: 'homesForSaleWidget',
  homesForSaleTitle: 'homesForSaleTitle',
  homesForSaleLocation: 'homesForSaleLocation',
  homesForSaleMapViewButton: 'homesForSaleMapViewButton',
  soldPricesWidget: 'soldPricesWidget',
  soldPricesTitle: 'soldPricesTitle',
  soldPricesMoreDataButton: 'soldPricesMoreDataButton',
  featuredHomesWidget: 'featuredHomesWidget',
  featuredHomesTitle: 'featuredHomesTitle',
  featuredHomesMoreListingsButton: 'featuredHomesMoreListingsButton',
  marketInsightsWidget: 'marketInsightsWidget',
  marketInsightsTitle: 'marketInsightsTitle',
  marketInsightsMoreNewsButton: 'marketInsightsMoreNewsButton',
  marketInsightsArticle: 'marketInsightsArticle',
  searchByKeywordsWidget: 'searchByKeywordsWidget',
  searchByKeywordsTitle: 'searchByKeywordsTitle',
  contentBlockImage: 'contentBlockImage',
  contentBlockTitle: 'contentBlockTitle',
  contentBlockParagraph: 'contentBlockParagraph',
  contentBlockButton: 'contentBlockButton',
  blogArticleSkeleton: 'blogArticleSkeleton',
};

export const keywordsIds = {
  soldPrices: 'SoldPrices',
  housesForSale: 'HousesforSale',
  condosForSale: 'CondosforSale',
  townhousesForSale: 'TownhousesforSale',
  homeAppraisal: 'HomeAppraisal',
  findAnAgent: 'FindanAgent',
  houses: 'Houses',
  threeBedHouses: '3BedHouses',
  twoBedCondos: '2BedCondos',
  oneBedCondos: '1BedCondos',
  condosForRent: 'CondosforRent',
  housesForRent: 'HousesforRent',
  condosUnder500K: 'CondosUnder500K',
  housesUnder1Mil: 'HousesUnder1mil',
  condos1000000: 'Condos1000000',
  mostExpensiveHouses: 'MostExpensiveHouses',
  luxuryCondos: 'LuxuryCondos',
  cheapestCondosInToronto: 'CheapestCondosinToronto',
  cheapestHousesInToronto: 'CheapestHousesinToronto',
  downtownTorontoCondos: 'DowntownTorontoCondos',
  searchBySchools: 'SearchBySchools',
};

export const preconIds = {
  preconCard: 'preconCard',
  preconFormTitle: 'preconFormTitle',
  preconFormDescription: 'preconFormDescription',
  preconFormFieldFirstName: 'preconFormFieldFirstName',
  preconFormFieldLastName: 'preconFormFieldLastName',
  preconFormFieldEmail: 'preconFormFieldEmail',
  preconFormFieldPhone: 'preconFormFieldPhone',
  preconFormFieldCheckbox: 'preconFormFieldCheckbox',
  preconFormFieldComment: 'preconFormFieldComment',
  preconSubmitRequestButton: 'preconSubmitRequestButton',
  preconTitle: 'title',
  preconPricing: 'pricing',
  preconDeveloper: 'developer',
  preconLocation: 'location',
  preconCoverImage: 'coverImage',
  preconEmptyCoverImage: 'emptyCoverImage',
  preconOccupancyDate: 'occupancyDate',
  // Photo gallery modal
  preconPhotoGallery: 'precon-photo-gallery', // Generated automatically
  photoGalleryTitle: 'photoGalleryTitle',
  photoGalleryLocation: 'photoGalleryLocation',
  photoGalleryRegisterLabel: 'photoGalleryRegisterLabel',
  photoGalleryRegisterButton: 'photoGalleryRegisterButton',
  photoGalleryCloseIcon: 'photoGalleryCloseIcon',
} as const;

export const profileUpdateIds = {
  fullNameEditButton: 'UpdateFullNameHeading',
  emailEditButton: 'UpdateEmailHeading',
  passwordEditButton: 'UpdatePasswordHeading',
  phoneEditButton: 'UpdatePhoneHeading',
  // Details
  updateProfileFirstName: 'updateProfileFirstName',
  updateProfileLastName: 'updateProfileLastName',
  updateNameButton: 'updateNameButton',
  updateProfilePhone: 'updateProfilePhone',
  updatePhoneButton: 'updatePhoneButton',
  updateProfileNewslettersCheckbox: 'updateProfileNewslettersCheckbox',
  // Email Update
  updateEmailNew: 'updateEmailNew',
  updateEmailButton: 'updateEmailButton',
  localeSelect: 'localeSelect',
  deleteAccountButton: 'deleteAccountButton',
} as const;

export const loginRegistrationIds = {
  loginModal: 'loginRegistration',
  initialForm: 'initialForm',
  loginRegistrationModal: 'loginRegistrationModal',
  backButton: 'backButton',
  roleSelectionForm: 'roleSelectionForm',
  roleSelectionAgent: 'roleSelectionAgent',
  roleSelectionBuyerOrSeller: 'roleSelectionBuyerOrSeller',
  roleSelectionOther: 'roleSelectionOther',
  changeEmailLink: 'changeEmail',
  loginRegistrationEmailTextField: 'loginRegistrationEmailTextField',
  passwordLoginModal: 'passwordLoginModal',
  forgotPassword: 'forgotPassword',
  signInButton: 'signInButton',
  createAccountFirstName: 'createAccountFirstName',
  createAccountLastName: 'createAccountLastName',
  createAccountPhone: 'createAccountPhone',
  createAccountPassword: 'createAccountPassword',
  createAccountNewslettersCheckbox: 'createAccountNewslettersCheckbox',
  privacyPolicyConsentCheckbox: 'privacyPolicyConsentCheckbox',
  marketingCommunicationsConsentCheckbox: 'marketingCommunicationsConsentCheckbox',
  signUpButton: 'signUpButton',
  loginRegistrationContinueButton: 'loginRegistrationContinueButton',
  forgotPasswordEmail: 'forgotPasswordEmail',
  forgotPasswordSubmit: 'forgotPasswordSubmit',
  formMessageError: 'formMessageError',
} as const;

export const blurIds = {
  overlaySignInBtn: 'overlaySignInBtn',
  overlayAcceptTermsBtn: 'overlayAcceptTermsBtn',
  overlaySignInMsg: 'overlaySignInMsg',
  overlayAcceptTermsMsg: 'overlayAcceptTermsMsg',
  blurredListingImageCarousel: 'blurredListingImageCarousel',
  blurredListingPrice: 'blurredListingPrice',
  termsOfUseAcceptButton: 'termsOfUseAcceptButton',
} as const;

export const listingPageModalIds = {
  listingModalTopBar: 'listingModalTopBar',
  openAddressPage: 'listingModalOpenAddressPage',
  closeListingModal: 'closeListingModal',
  listingImageCarousel: 'listingImageCarousel',
  swiperCarouselComponent: 'swiperCarouselComponent',
  modalPriceInfoSection: 'listingModalPriceInfo',
  priceHistoryBtn: 'priceHistoryButton',
  virtualTourBtn: 'virtualTourBtn',
  takeTourBtn: 'takeATourButton',
  modalListingStatus: 'modalListingStatus',
  listingStatus: 'listingStatus',
  listingPriceModal: 'listingPriceModal',
  soldListingListedPrice: 'soldListingListedPrice',
  modalListingTimeStamp: 'modalListingTimeStamp',
  listingAddress: 'streetAddress',
  listingBedIcon: 'listingBedIcon',
  listingBathrooms: 'listingBathIcon',
  listingSqft: 'listingDimensionsIcon',
  listingCar: 'listingCarIcon',
  editIcon: 'EditIcon',
  closeIcon: 'CloseIcon',
  listingKeyFactsTab: 'listingKeyFactsTab',
  listingDescriptionTab: 'listingDescriptionTab',
  listingRoomsTab: 'listingRoomsTab',
  listingMapTab: 'listingMapTab',
  listingSchoolsTab: 'listingSchoolsTab',
  listingMortgageTab: 'listingMortgageTab',
  listingDemographicsTab: 'listingDemographicsTab',
  listingCommuteTab: 'listingCommuteTab',
  keyFactsPropertyAddress: 'addressKeyFacts',
  walkScoreComponent: 'walkScoreComponent',
  detailsTable: 'detailsTable',
  descriptionDetailText: 'descriptionDetailText',
  descriptionShowMoreToggle: 'descriptionShowMoreToggle',
  descriptionExtra: 'descriptionExtra',
  descriptionDisclaimer: 'descriptionDisclaimer',
  roomsDetailsSection: 'roomsDetailsSection',
  listingMap: 'listingMap',
  priceHistorySection: 'priceHistorySection',
  priceHistoryHeading: 'priceHistoryHeading',
  priceHistoryRow: 'priceHistoryRow',
  currentPriceHistoryRow: 'currentPriceHistoryRow',
  priceHistoryRowDate: 'priceHistoryRowDate',
  priceHistoryRowPrice: 'priceHistoryRowPrice',
  priceHistoryRowListPrice: 'priceHistoryRowListPrice',
  priceHistoryRowListStatus: 'priceHistoryRowListStatus',
  priceHistoryRowSoldDate: 'priceHistoryRowSoldDate',
  priceHistoryRowSoldPrice: 'priceHistoryRowSoldPrice',
  listingKeyInfo: 'listingKeyInfo',
  secondaryInfo: 'listingSecondaryInfo',
  charts: 'listingCharts',
  avgSoldPriceTabLink: 'Avg.SoldPriceTabLink',
  avgSoldPriceTab: 'avgSoldPriceTab',
  salesActivityTabLink: 'SalesActivityTabLink',
  salesActivityTab: 'salesActivityTab',
  zoopraisal: 'listingZoopraisal',
  successMessage: 'listingSuccessMessage',
  similarListingsSections: 'similarListingsSections',
  comparableProperties: 'comparableProperties',
  connectionRequestForm: 'connectionRequestForm',
  connectionRequestFormTitle: 'connectionRequestFormTitle',
  requestfirstname: 'requestfirstname',
  requestlastname: 'requestlastname',
  requestemail: 'requestemail',
  requestphonenumber: 'requestphonenumber',
  requestAddComment: 'requestAddComment',
  requestComments: 'requestComments',
  requestViewingCheckbox: 'requestViewingCheckbox',
  newslettersCheckbox: 'createAccountNewslettersCheckbox',
  elementarySchoolsButton: 'elementarySchoolsButton',
  secondarySchoolsButton: 'secondarySchoolsButton',
  favouritePrompt: 'FavouritePrompt',
  favouritePromptText: 'FavouritePromptText',
  favouritePromptAddButton: 'FavouritePromptAddButton',
  favouritePromptSavedListingsLink: 'FavouritePromptSavedListingsLink',
} as const;

export const listingCardIds = {
  listingGrid: 'listingGrid',
  listingCard: 'listingCard',
  listingImage: 'listingCardImage',
  listingPrice: 'listingPrice',
  listingCardPrice: 'listingCardPrice',
  listingTimeStamp: 'listingTimeStamp',
  listingAddress: 'streetAddress',
  listingBeds: 'listingBeds',
  listingBathrooms: 'listingBathrooms',
  listingSqft: 'listingSqft',
  listingMlsNum: 'listingMls',
  listingSmartTags: 'listingCardSmartTags',
  favouriteToggle: 'favouriteToggle',
  favouriteBurst: 'favouriteBurst',
  listingsSwiper: 'listingsSwiper',
  newListingRow: 'newListingRow',
  nearbyListings: 'NearbyListings',
  nearbyViewMore: 'NearbyViewMore',
} as const;

export const mapPageIds = {
  listingsSidebar: 'listingsSidebar',
  listingsCount: 'listingsCount',
  hideShowListBtn: 'hideShowListBtn',
  listingsScrollableList: 'listingsScrollableList',
  listingPinPopover: 'listingPinPopover',
  listingsCardPopover: 'listingCardSmall',
  mapPageSearchbar: 'mapPageSearchbar',
  searchPageController: 'searchPageController',
  mapPageSearchbarClear: 'mapPageSearchbarClear',
  mapListToggleButton: 'mapListToggleButton',
  listingMap: 'listingMap',
  nearbyAreas: 'NearbyAreas',
  mapPinType: 'listingCluster',
  mapPin: 'mapPin',
  mapPinFull: 'mapPinFull',
  mapPinDot: 'mapPinDot',
  mapPinBuilding: 'mapPinBuilding',
  mapSatellite: 'mapSatellite',
  mapAmenities: 'mapAmenities',
} as const;

export const searchFilterIds = {
  removeBoundaryButton: 'removeBoundaryButton',
  filterModal: 'filterModal',
  closeIcon: 'CloseIcon',
  breadcrumbs: 'Breadcrumbs',
  resetFiltersButton: 'resetFiltersButton',
  moreButtonHomepage: 'moreButtonHomepage',
  searchInput: 'searchInput',

  //Buy or Rent filter
  buyOrRentDropdownMap: 'buyOrRentDropdownMap',
  buyRentDropdown: 'buyRentDropdown',
  homepageBuyRentDropdownOptions: 'homepageBuyRentDropdownOptions',

  // Listing Status Filter
  listingStatusDropdownMap: 'listingStatusDropdownMap',
  listingStatusOptionsHomepage: 'listingStatusOptionsHomepage',

  // Home Type Filter
  homeTypeDropdownMap: 'homeTypeDropdownMap',
  homeTypeDropdownMapLabel: 'homeTypeDropdownMapLabel',
  homeTypeDropdownSavedSearch: 'homeTypeDropdownSavedSearch',

  schoolPin: 'schoolPin',

  // Price Filter
  priceRangeDropdownMap: 'priceRangeDropdownMap',
  priceRangeDropdownMapLabel: 'priceRangeDropdownMapLabel',
  priceFilterMinInput: 'priceFilterMinInput',
  priceFilterMaxInput: 'priceFilterMaxInput',
  priceRangeDropdownApply: 'priceRangeDropdownApply',
  minPriceFilterOptions: 'minPriceFilterOptions',
  maxPriceFilterOptions: 'maxPriceFilterOptions',
  priceFilterSlider: 'priceFilterSlider',
  priceRangeDropdownReset: 'priceRangeDropdownReset',

  // Beds Filter
  bedsDropdownMapLabel: 'bedsDropdownMapLabel',
  bedsDropdownMap: 'bedsDropdownMap',
  bedOptionsDropdownSelect: 'bedOptionsDropdownSelect',
  bedOptionsDropdown: 'bedOptionsDropdown',

  // Baths Filter
  mapButtonAreaPage: 'listButtonMapPage',
  saveSearchButtonMapPage: 'saveSearchButtonMapPage',

  // Sqft Filter
  sqftDropdownMap: 'sqftDropdownMap',
  sqftDropdown: 'sqftDropdown',
  sqftDropdownApply: 'sqftDropdownApply',
  sqftFilterMaxInput: 'sqftFilterMaxInput',
  sqftFilterMinInput: 'sqftFilterMinInput',
  minSqftFilterOptions: 'minSqftFilterOptions',
  maxSqftFilterOptions: 'maxSqftFilterOptions',
  // Amenities Filter
  garageCheckbox: 'garageCheckbox',
  openHousesCheckbox: 'openHousesCheckbox',
  poolCheckbox: 'poolCheckbox',
  waterfrontCheckbox: 'waterfrontCheckbox',
  fireplaceCheckbox: 'fireplaceCheckbox',
  hasImageCheckbox: 'hasImageCheckbox',
  showComingSoonCheckbox: 'showComingSoonCheckbox',

  // Filter Modal Constants
  bedsSavedSearchesMinus: 'bedsSavedSearchesMinus',
  bedsSavedSearchesPlus: 'bedsSavedSearchesPlus',
  bathroomsSavedSearchesPlus: 'bathroomsSavedSearchesPlus',
  applyFiltersButton: 'applyFiltersButton',
  deletePrompt: 'deletePrompt',
  deleteButtonModal: 'deleteSearch',
  moreButtonMapPage: 'moreButtonMapPage',
  mobileFilterButton: 'mobileFilterButton',
  okButtonModal: 'okButtonModal',
  saveEditSearch: 'saveEditSearch',
  parkingSavedSearchesPlus: 'parkingSavedSearchesPlus',
  saveSearchButton: 'saveSearchButton',
  saveSearchModal: 'saveSearchModal',
  savedSearchNameModal: 'savedSearchNameModal',
  savedSearchNotificationFrequency: 'savedSearchNotificationFrequency',
  maintenanceFees: 'maintenanceFees',

  // Dropdown
  locationsDropdownSection: 'LocationsDropdownSection',
  listingsDropdownSection: 'ListingsDropdownSection',
  buildingsDropdownSection: 'BuildingsDropdownSection',
  schoolsDropdownSection: 'SchoolsDropdownSection',
  popularSearchesDropdownSection: 'PopularSearchesDropdownSection',
  listingStatusDropdownHomepage: 'listingStatusDropdownHomepage',
  homeTypeDropdownHomepage: 'homeTypeDropdownHomepage',
  priceRangeDropdownHomepage: 'priceRangeDropdownHomepage',
  bedsDropdownHomepage: 'bedsDropdownHomepage',
  sortByDropdown: 'sortByDropdown',

  // Check Box
  checkboxOption: 'CheckboxOption',
  houseCheckboxOption: 'HouseCheckboxOption',
  townhouseCheckboxOption: 'TownhouseCheckboxOption',
  condoCheckboxOption: 'CondoCheckboxOption',
  landCheckboxOption: 'LandCheckboxOption',
  commercialCheckboxOption: 'CommercialCheckboxOption',
  farmCheckboxOption: 'FarmCheckboxOption',
  orMoreBedCheckboxOption: 'orMoreBedCheckboxOption',
  createAccountNewslettersCheckbox: 'createAccountNewslettersCheckbox',

  // Saved Searches Header + Dropdown
  runSearchBtn: 'runSearchButton',
  viewAllSavedSearches: 'viewAllSavedSearches',
  myZoocasa: 'myZoocasa',
  savedSearchCard: 'SavedSearchCard',
  savedPriceRange: 'PriceRange',
  savedBedroom: 'Bedroom',
  savedBathroom: 'Bathroom',
  savedParking: 'Parking',
  savedSearch: 'SavedSearch',
  daysOnMarketDropdown: 'daysOnMarketDropdown',
  lockerDropdown: 'lockerDropdown',
  minPriceSavedSearch: 'minPriceSavedSearch',
  maxPriceSavedSearch: 'maxPriceSavedSearch',
  minSquareFeetSavedSearch: 'minSquareFeetSavedSearch',
  maxSquareFeetSavedSearch: 'maxSquareFeetSavedSearch',
  dropdownOption: 'DropdownOption',
  bedsSavedSearches: 'bedsSavedSearches',
  bedsCheckboxSavedSearches: 'bedsCheckboxSavedSearches',
  bedsCheckboxSavedSearchesInput: 'bedsCheckboxSavedSearchesInput',
  bathroomsSavedSearches: 'bathroomsSavedSearches',
  bathroomsCheckboxSavedSearches: 'bathroomsCheckboxSavedSearches',
  parkingSavedSearches: 'parkingSavedSearches',
  parkingCheckboxSavedSearches: 'parkingCheckboxSavedSearches',
  providerIdInput: 'providerIdInput',

  // search bar
  searchbar: 'searchbar',
  searchbarButton: 'searchbarButton',
  searchbarFilters: 'searchbarFilters',
  recentSearchesDropdownSection: 'RecentSearchesDropdownSection',
  searchbarFilterButton: 'searchbarFilterButton',

  // map
  searchMap: 'searchMap',
  mapZoomIn: 'mapZoomIn',

  // School
  schoolPinPopover: 'schoolPinPopover',
  showSchoolPins: 'showSchoolPins',
  showSchoolsToggle: 'showSchoolsToggle',
  applySchoolFilters: 'applySchoolFilters',
} as const;

export const headerIds = {
  header: 'header',
  zoocasaHeaderLogo: 'zoocasaHeaderLogo',
  headerSearchIcon: 'headerSearchIcon',
  headerSearchIconMobile: 'headerSearchIconMobile',
  soldPricesHeader: 'soldPricesHeader',
  newHomesHeader: 'newHomesHeader',
  sellWithUsHeader: 'sellWithUsHeader',
  mapHeaderDesktop: 'mapHeaderDesktop',
  mapHeaderMobile: 'mapHeaderMobile',
  marketInsightsHeader: 'marketInsightsHeader',
  mySearchesHeader: 'mySearchesHeader',
  myLastSearchSavedSearch: 'myLastSearchSavedSearch',
  loggedInUser: 'loggedInUser',
  loginHeader: 'loginHeader',
  loginMobile: 'loginMobile',
  mobileMenu: 'mobileMenu',
  mobilePanel: 'mobilePanel',
  pageHeading: 'pageHeading',
  aboutUsMenu: 'aboutUsMenu',
} as const;

export const smartChat = {
  assistantAvatar: 'assistantAvatar',
  assistantChatMessage: 'assistantChatMessage',
  userChatMessage: 'userChatMessage',
  closePopup: 'closePopup',
  chatIcon: 'chatIcon',
  popupMessage: 'popupMessage',
  closeChatHeader: 'closeChatHeader',
  closeChatIcon: 'closeChatIcon',
  sendBtn: 'sendBtn',
  connectWithAgentBtn: 'connectWithAgentBtn',
  bookViewingBtn: 'bookViewingBtn',
  haveQuestionsBtn: 'haveQuestionsBtn',
  textBar: 'textBar',
  smartChatHeader: 'smartChatHeader',
  infoOutlinedIcon: 'InfoOutlinedIcon',
  closeIcon: 'closeIcon',
} as const;

// Third party lib IDs (not data-testids)
export const cookieBanner = {
  consentBlackbar: 'consent_blackbar',
  trusteConsentTrack: 'truste-consent-track',
  trusteConsentContent: 'truste-consent-content',
  trusteCookieImage: 'truste-cookie-image',
  trusteConsentText: 'truste-consent-text',
  trusteConsentButtons: 'truste-consent-buttons',
  trusteRepopMsg: 'truste-repop-msg',
  trusteConsentAcceptAllButton: 'truste-consent-button',
  trusteConsentRejectAllButton: 'truste-consent-required',
  trusteConsentCustomizeButton: 'truste-show-consent',
} as const;

export const buyWithZoocasa = {
  buyFirstHomeSection: 'buyFirstHome',
  connectWithAgentBtn: 'connectWithAgent',
  callUsNowBtn: 'callUs',
  createAccountSection: 'createAccountSection',
  createAccountBtn: 'createAccount',
  buyersGuideSection: 'buyersGuideSection',
  buyersGuideBtn: 'buyersGuide',
  viewMoreAvailableBtn: 'viewMoreAvailable',
  viewMoreSoldBtn: 'viewMoreSold',
} as const;

export const agentSearchIds = {
  agentSearchHeader: 'agentSearchHeader',
  countryDropdown: 'countryDropdown',
  locationInput: 'locationInput',
  agentNameInput: 'agentNameInput',
  agentsResultCount: 'agentsResultCount',
  agentCard: 'agentCard',
  agentNoResultsMessage: 'agentNoResultsMessage',
  agentProfileFirstName: 'agentProfileFirstName',
  agentProfileLastName: 'agentProfileLastName',
  agentProfileContactInfo: 'agentProfileContactInfo',
  agentProfileAbout: 'agentProfileAbout',
  agentCardName: 'agentCardName',
  agentCardLocation: 'agentCardLocation',
  agentCardLicense: 'agentCardLicense',
  agentCardBio: 'agentCardBio',
  agentProfileLicense: 'agentProfileLicense',
  countryDropdownOption: 'countryDropdownOption',
  agentSearchIcon: 'agentSearchIcon',
  agentSearchDropdownOption: 'agentSearchDropdownOption',
  inputWrapper: 'input-wrapper',
  suggestionDropdown: 'suggestion-dropdown',
  suggestionItem: 'suggestion-item',
  clearButton: 'clear-button',
  dropdownCloseButton: 'dropdown-close-button',
} as const;

export const contentPageIds = {
  blogPost: 'blogPost',
  heroSlide: 'heroSlide',
} as const;

export const benefitsTestCards = [
  {
    type: 'card' as const,
    title: 'Test Card 1',
    description: 'This is the first test card.',
  },
  {
    type: 'image' as const,
    url: '/test-image.jpg',
  },
  {
    type: 'card' as const,
    title: 'Test Card 2',
    description: 'This is the second test card.',
  },
];

export const commercialTestIds = {
  duplicateMetrics: 'duplicate-metrics',
} as const;

export const SAMPLE_PROGRAMS = [
  {
    image: '/img1.png',
    imageAlt: 'Alt 1',
    title: 'Title 1',
    description: 'Desc 1',
    buttonText: 'Button 1',
    buttonLink: '/link1',
    buttonClickEvent: 'evt1',
  },
  {
    image: '/img2.png',
    imageAlt: 'Alt 2',
    title: 'Title 2',
    description: 'Desc 2',
    buttonText: 'Button 2',
    buttonLink: '/link2',
    buttonClickEvent: 'evt2',
  },
] as const;

/** @see src/components/pages/address/components/neighbourhood-demographics/index.tsx */
export const neighbourhoodTestIds = {
  averageHouseholdIncome: 'averageHouseholdIncome',
  propertiesOwned: 'propertiesOwned',
  populationTotal: 'populationTotal',
  propertiesRented: 'propertiesRented',
  populationByAge: 'populationByAge',
} as const;

export const NAMESPACE = 'ns';